module.exports = __webpack_public_path__ + "img/banner-1.609b9850.jpg";